export default "__VITE_ASSET__fe215988__"